import { useLocation } from 'react-router-dom';

import ActionNotification from '../components/Assets/ActionNotification';
import LeftBand from '../features/auth/components/login/leftBand/LeftBand';

import PasswordResetForm from '../features/auth/components/passwordReset/PasswordResetForm';
import PasswordResetHeader from '../features/auth/components/passwordReset/PasswordResetHeader';
import './styles/passwordResetPage.scss';

function PasswordResetPage() {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="password">
      <LeftBand />
      <main className="password-content">
        <div className="password-content-elt">
          <PasswordResetHeader path={path} />
          <div className="password-form-wrapper">
            <ActionNotification />
            <PasswordResetForm path={path} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default PasswordResetPage;
